import { StrictMode } from "react"
import { createRoot } from "react-dom/client"

import App from "./App"
import "./index.css"
import "./i18n"

const root = document.getElementById("root")
if (!root) throw new Error("Root element missing from index.html")

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
